import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  items: [],
  totalRows: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_ADAPTER:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false
      }

    case ActionTypes.RECEIVE_ADAPTER:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        lastUpdated: action.receivedAt
      }
    
    case ActionTypes.TOTALROWS_ADAPTER:
      return {
        ...state,
        totalRows: action.totalRows
      }

    default:
      return state
  }
}